var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCookies } from "react-cookie";
import { CookieKeys } from "../../constants/cookies";
import styles from "../../styles/GameStatus.module.scss";
import { Icon } from "semantic-ui-react";
var GameStatus = function () {
    var _a = useCookies([CookieKeys.isDaily]), cookies = _a[0], _setCookies = _a[1], deleteCookie = _a[2];
    var isDaily = cookies[CookieKeys.isDaily] !== "false";
    var handleGoBackToDaily = function () {
        deleteCookie(CookieKeys.isDaily);
        window.location.reload();
    };
    // If you're working on the daily
    // If you're not working on the daily
    // Link back to the daily if you're not on it.
    // When the game plans to update
    if (isDaily)
        return _jsxs("p", __assign({ className: styles.message }, { children: ["You are guessing the Commander of the Day in ", _jsx(Icon, { name: "calendar alternate outline" }, void 0), "Daily Mode."] }), void 0);
    return (_jsxs("div", __assign({ className: styles.message }, { children: ["This is a random Commander in ", _jsx(Icon, { name: "shuffle" }, void 0), "Infinite Mode. If you\u2019d like to return to ", _jsx(Icon, { name: "calendar alternate outline" }, void 0), "Daily Mode,", _jsx("button", __assign({ className: styles.goBack, onClick: handleGoBackToDaily }, { children: "click here" }), void 0)] }), void 0));
};
export default GameStatus;
